import $ from 'jquery';
import 'select2';

export default class SelectBox {
  constructor(element) {
    this.$element = $(element);
    this.create();
  }

  create() {
    // const placeholder = $('.link-read-more .read-more-text', this.$element);
    const placeholderText = $('.link-read-more .read-more-text', this.$element).text();
    const $select = $(`<select class="locations" data-placeholder="${placeholderText}"></select>`);
    const $options = this.$element.find('li');

    // $select.append(`<option selected disabled value="0">${placeholderText}</option>`);

    $options.each((i, item) => {
      const label = $(item).text();
      const value = $('a', item).attr('href');
      const target = ($('a', item).attr('target')) ? '_blank' : '_self';
      // const target = $('a', item).attr('target');
      let option = '';
      if (i === 0) {
        option = `<option selected disabled value="${value}">${label}</option>`;
      } else {
        option = `<option target="${target}" value="${value}">${label}</option>`;
      }
      $select.append(option);
    });

    this.$element.append($select);
    $select.select2();

    // Add an on selection change event handler which redirects users based on there selection.
    $select.on('select2:select', (event) => {
      const { data } = event.params;
      if (data && data.id && data.element && data.element.attributes
        && data.element.attributes.target && data.element.attributes.target.value) {
        const location = data.element.attributes.target.value;
        window.open(data.id, location);
      }
    });

    // Add ready class to fade it in.
    $select.closest('.node-links').addClass('ready');
  }
}
